import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg';
import { GlobalSearchService } from './global-search.service';
import { GlobalSearchEntitiesService } from './global-search-entities.service';
import { NbCardModule, NbInputModule, NbAutocompleteModule, NbFormFieldModule, NbOptionModule, NbIconModule} from '@nebular/theme';
import { MaterialModule } from 'src/app/shared/material.module';
import { GlobalSearchComponent } from './global-search.component';

@NgModule({
  declarations: [GlobalSearchComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    InlineSVGModule,
    CommonModule,
    ReactiveFormsModule,
    InlineSVGModule,
    NbCardModule,
    NbInputModule,
    NbFormFieldModule,
    NbAutocompleteModule,
    NbOptionModule,
    NbIconModule,
  ],
  providers: [
    GlobalSearchService,
    GlobalSearchEntitiesService,
  ],
  exports: [GlobalSearchComponent]
})
export class GlobalSearchModule { }
